// src/hooks/useProfile.ts
import { useQuery } from "@tanstack/react-query";
import { userService } from "@/services/userService";

// the way this works is
// user opens connections modal
// api.socials.get(`/connections/${userId}`)
// user id here is the user the viewer is looking at (/account/:userId)
// if the user id is null, then the viewer is looking at their own connections (i.e. on their own account page)
// if the user id is not null, then the viewer is looking at someone else's connections (i.e. on another user's account page)
// we will receive a list of followers and following
// we send only the id of the user we're viewing

export function useConnections(userId: string) {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ["connections", userId],
    queryFn: () => userService.getFriends(userId),
    enabled: !!userId,
    staleTime: Infinity,
  });

  // returns {followers: [], following: []}

  return { data, isLoading, error, refetch };
}
